// Common
import { ADialogContentProps } from '../../../common/dialog';

export const dialogContentProps: ADialogContentProps = {
    size: 'md',
};
